<template>
  <customModal
    v-if="show"
    :containersm="true"
    @close-modal="handleClose"
  >
    <template #title>{{ documentTitle }}</template>
    <template #body>
      <div class="signature-list-scroll">
        <div
          v-for="(item, index) in signItems"
          :key="item.signatureKey"
          class="signature-item-row"
          :class="{ 'row-divider': index !== signItems.length - 1 }"
        >
          <div class="signature-item-left">
            <div class="signature-item-name">{{ item.displayName }}</div>
            <div v-if="item.signed" class="signature-item-date">
              {{ filter(item.signedAt) }} {{toTime(item.signedAt) }} 
            </div>
          </div>
          <div class="signature-item-right">
            <span v-if="item.signed" class="badge-signed">Signed</span>
            <span v-else class="badge-pending">Pending</span>
          </div>
        </div>

        <div v-if="!signItems || signItems.length === 0" class="text-center small-text">
          No signature items found.
        </div>
      </div>
    </template>
  </customModal>
</template>

<script>
import moment from "moment";
import customModal from "../customModal/customModal.vue";

export default {
  name: "SignatureStatusModal",
  components: {
    customModal,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    documentTitle: {
      type: String,
      default: "",
    },
    signItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      defaultdate:"",
      defaultTime:"",
    };
  },
  emits: ["close"],
  mounted() {
    this.defaultdate = localStorage.getItem("dateformat");
    this.defaultTime = localStorage.getItem("timeformat");
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    formatSignedDate(dateStr) {
      if (!dateStr) return "";
      const d = new Date(dateStr);
      return d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    },
    filter(date) {
      if (date) {
          return moment(date).format(this.defaultdate)
      }
    },
    toTime(data) {
      if (data) {
        return moment(data).format(this.defaultTime);
      }
    },
  },
};
</script>

<style scoped>
.signature-item-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 14px 0;
}

.row-divider {
  border-bottom: 1px solid #f2f2f2;
}

.signature-item-name {
  font-weight: 600;
  font-size: 14px;
  color: #000;
}

.signature-item-date {
  font-size: 12px;
  color: #000;
  margin-top: 2px;
}

.badge-signed {
  color: #1ab394;
  font-weight: 600;
  font-size: 13px;
}

.badge-pending {
  color: #f8ac59;
  font-weight: 600;
  font-size: 13px;
  background-color: #fdf0dc;
  padding: 2px 12px;
  border-radius: 12px;
}
.signature-list-scroll {
  max-height: 420px; 
  overflow-y: auto;
  padding-right: 6px;
}

.signature-list-scroll::-webkit-scrollbar {
  width: 6px;
}
.signature-list-scroll::-webkit-scrollbar-thumb {
  background-color: #d9d9d9;
  border-radius: 4px;
}
.signature-list-scroll::-webkit-scrollbar-track {
  background: transparent;
}
</style>